import hasDiscount from 'functions/hasDiscount';

const calcTagDiscount = price => {
  if (!hasDiscount(price?.current_price, price?.original_price, price?.currency?.symbol)) {
    return null;
  }

  return Math.round((price.current_price.full / price.original_price.full) * 100 - 100);
};

export default calcTagDiscount;
